import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

function RedirectModal(props) {
  const { closeModal } = props;
  const navigate = useNavigate();

  const handleRedirect = () => {
    closeModal('redirectModal');
    navigate('/alert-plus/manage');
  };

  return (
    <div className="modal fade" id="redirectModal" tabIndex="-1" aria-labelledby="redirectModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <div className="modal-title">
              <FormattedMessage id="REDIRECT_ALERT_TITLE" />
            </div>
          </div>
          <div className="modal-body">
            <FormattedMessage id="REDIRECT_ALERT_ENDED" />
          </div>
          <div className="modal-footer d-flex justify-content-center">
            <button 
              className="btn save-btn" 
              type="button" 
              onClick={handleRedirect}
            >
              <FormattedMessage id="CONFIRM_BTN" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RedirectModal;
